<template>
<div >
  <!-- 业务范围 -->
  <div>
        <div  class="ye-tou">
              業務範圍
        </div>
        <div class="ye-scope">
          ——  SCOPE OF SERVICES  ——
      </div>
      <div class="ye-text" @click="Digital">
            <div class="ye-left" >
                <img class="shu-img" src="../../static/imgs/shuma.png" alt="">
                <span class="ye-span">數碼化科技支援</span>
            </div>
            <div class="ye-kai">
                 為商戶提供各種SAAS軟件開發和技術上的支援，包括開發設計網頁、網店和獨立微信商城等等。
            </div>
      </div>
      <div class="ye-text1"  @click="pay">
            <div class="ye-left" >
                <img class="shu-img" src="../../static/imgs/dianzi.png" alt="">
                <span class="ye-span">電子支付平台開通</span>
            </div>
            <div class="ye-kai">
                提供一站式支付方案，與各大電子支付平台賬戶連接和維護，包括中港兩地微信支付和支付寶系統。客戶付款及對賬記錄；提供POS和支付終端便捷支付等等。
            </div>
      </div>
       <div class="ye-text2"  @click="leave">
            <div class="ye-left" >
                <img class="shu-img" src="../../static/imgs/kaituo.png" alt="">
                <span class="ye-span">開拓中國市場</span>
            </div>
            <div class="ye-kai">
              憑藉我們經驗豐富的内地市場推廣團隊，成功協助多家香港公司在大灣區提升公司及產品知名度和銷售額。案例包括醫療行業（網上預約和支付系統），物流行業（追蹤系統，落單）。
            </div>
      </div>
      <!-- tanchaung -->
      <div class='popContainer' v-if="show">
            <div class="ye-fix">
                <div class="te-tex">
                      <div @click="show=false;">
                           <img class="cha-img" src="../../static/imgs/cha.png" alt="">
                      </div>
                     <img class="xing-img" src="../../static/imgs/juxing.png" alt="">
                     <div class="te-duo">多種支付渠道</div>
                     <div class="te-tan">
                         <div >
                           <img class="xi-img" src="../../static/imgs/xiaoxin.png" alt="">
                         </div>
                         <div style="width:33px;">

                         </div>
                         <div>
                           <img  class="xin-img" src="../../static/imgs/xiaobao.png" alt="">
                         </div>
                     </div>
                     <div class="te-tan1">
                            <div class="te-mt">
                              <img class="vlst-img" src="../../static/imgs/visa.png" alt="">
                            </div>
                            <div class="te-mt">
                              <img class="mast-img" src="../../static/imgs/mast.png" alt="">
                            </div>
                            <div>
                              <img class="bada-img" src="../../static/imgs/bada.png" alt="">
                            </div>
                     </div>
                </div>
            </div>
       </div>
       <div class="ye-yin">
           營運數據收集
       </div>
       <div class="ye-shuo">
              <div>
                  <img  class="xiao-img" src="../../static/imgs/xiaoshou.png" alt="">
              </div>
              <div style="margin-left:15px;">
                    <div class="ye-shu">銷售數據</div>
                    <div class="ye-ji">記錄消費者游覽網站的行為數據，深度了解銷售數據趨勢和消費行為，增加銷售效益。</div>
              </div>
       </div>
       <div class="ye-xu"></div>
       <div class="ye-shuo">
              <div>
                  <img  class="xiao-img" src="../../static/imgs/yonghu.png" alt="">
              </div>
              <div style="margin-left:15px;">
                    <div class="ye-shu">用戶數據</div>
                    <div class="ye-ji">幫助商戶確定獲客渠道，發掘用戶的潛力，優化用戶體驗，提升用戶忠誠度，增加客戶消費頻率提升ARPU。</div>
              </div>
       </div>
         <div class="ye-xu"></div>
       <div class="ye-shuo">
              <div>
                  <img  class="xiao-img" src="../../static/imgs/changping.png" alt="">
              </div>
              <div style="margin-left:15px;">
                    <div class="ye-shu">產品數據</div>
                    <div class="ye-ji">全面數據收集，還原用戶行為軌跡，了解產品實際銷售情況，利用數據驅動產品的更新和升級。</div>
              </div>
       </div>
       <div class="ye-liao">
                 <div class="ye-zhi">為各行各業提供一站式<br>電子商務系統和支付方案</div>
                 <div class="ye-jiao">
                       <div class="liao-kuang">
                            <div>
                              <img class="liao-img" src="../../static/imgs/yinliao.png" alt="">
                            </div>
                            <div class="yin-liao">
                               醫療
                            </div>
                       </div>
                       <div>
                             <div>
                              <img class="liao-img" src="../../static/imgs/jiaoyu.png" alt="">
                            </div>
                            <div class="yin-liao">
                              教育
                            </div>
                       </div>
                 </div>
                  <div class="ye-jiao">
                       <div class="liao-kuang">
                            <div>
                              <img class="liao-img" src="../../static/imgs/wuliu.png" alt="">
                            </div>
                            <div class="yin-liao">
                              物流
                            </div>
                       </div>
                       <div>
                             <div>
                              <img class="liao-img" src="../../static/imgs/dianshao.png" alt="">
                            </div>
                            <div class="yin-liao">
                             電商
                            </div>
                       </div>
                 </div>
       </div>
  </div>
  <!-- 便胜之处 -->
  <div>
           <div  class="ye-tou">
            優勝之處
        </div>
        <div class="ye-scope">
          ——  STRENGTH ——
       </div>
       <div class="bian">
              <div class="bian-left">
                   <div>
                       <img class="bian-img" src="../../static/imgs/shuzhi.png" alt="">
                   </div>
                   <div class="bian-text">
                       熟悉中港互聯網市場
                   </div>
              </div>
              <div class="bian-right">
                  <div>
                       <img class="bian-img" src="../../static/imgs/duonian.png" alt="">
                  </div>
                  <div class="bian-text1">
                      多年電子銷售推廣經驗
                  </div>
              </div>
          </div>
       <div class="bian1">
              <div class="bian-left">
                   <div>
                       <img class="bian-img" src="../../static/imgs/wanshao.png" alt="">
                   </div>
                   <div class="bian-text2">
                     完善的數據管理
                   </div>
              </div>
              <div class="bian-right">
                  <div>
                       <img class="bian-img" src="../../static/imgs/zhuangzhu.png" alt="">
                  </div>
                  <div class="bian-text2">
                     專注行業解決方案
                  </div>
              </div>
       </div>
        <div class="bian1">
              <div class="bian-left">
                   <div>
                       <img class="bian-img" src="../../static/imgs/zhifu.png" alt="">
                   </div>
                   <div class="bian-text2">
                     支付行業專家
                   </div>
              </div>
              <div class="bian-right">
                  <div>
                       <img class="bian-img" src="../../static/imgs/yuwei.png" alt="">
                  </div>
                  <div class="bian-text3">
                     與微信/支付寶直接聯接
                  </div>
              </div>
       </div>

  </div>
  <!-- 策略合作伙伴 -->
   <div >
         <div class="ce-tou">
                 <div  class="ye-tou">
                   策略合作夥伴
                  </div>
                <div class="ye-scope">
                  —— STRATEGIC PARTNERS  ——
               </div>
               <div class="ce-cxc">
                      <div >
                           <img @click="cxc" class="cxc-img" src="../../static/imgs/cxc.png" alt="">
                             <div class="cha_xun">查詢請按圖</div>
                      </div>
                      <div class="cxc-kuai">
                           <div class="cxc-text" @click="cxc">CXC快遞中心有限公司</div>
                           <div class="cxc-jian">
                             CXC快遞中心有限公司（CXC EXPRESS LIMITED ）始創於2000年，為香港本地最早及最具規模快遞服務供應商之一。
每日處理過萬快件，包括國際件及本地件，公司現有人員超過300名，擁有龐大的車隊網絡，覆蓋全港各地區的快遞網絡，為用戶提供遞送、倉儲與供應鏈管理、代收貨款與清關等一對一的快遞服務。
                           </div>
                      </div>
               </div>
         </div>
   </div>
   <!-- 最新动态 -->
   <div>
              <div  class="ye-tou">
                   最新動態
                  </div>
                <div class="ye-scope">
                  ——  INDUSTRY NEWS ——
               </div>
               <div style="height:10px;">

               </div>
               <div class="zui-text" @click="gan(item.tiaozhuan_url)" v-for="item in tableData" :key="item.id">
                    <div>
                        <img class="jian-img" src="../../static/imgs/jiantou.png" alt="">
                    </div>
                    <div class="zui-teng">
                       {{item.title}}
                    </div>
                    <div class="zui-ri">
                           {{item.inputtime}}
                    </div>
               </div>





               <div style="height:50px;">

               </div>

   </div>
   <!-- 关于我们 -->
   <div>
        <div class="guan-kuang">
                <div  class="guan-tou">
                  關於我們
                  </div>
                <div class="guan-ab">
                  —— ABOUT US ——
               </div>
               <div class="guan-login">
                 立即選用前寶通 業務發展好輕鬆
               </div>
               <div class="guan-text">
                 在支付業務外，我們為你考慮更多
               </div>
               <div class="guan-tong">
                   <div style="text-align:center;">
                      <img class="qian-img" src="../../static/imgs/qianbaotong.png" alt="">
                      <div class="qian-jian">
                          FinTech Awards2019年金融科技大獎
                        </div>

                   </div>
                   <div style="text-align:center;">
                     <div>
                           <img class="jiang-img" src="../../static/imgs/jiang.jpg" alt="">
                             <div class="qian-jian1">IFTA FinTech  Achievement Award 2019</div>
                     </div>


                   </div>

               </div>
               <!-- <div class="qian-text">
                        <div class="qian-jian">
                          FinTech Awards<br>2019年金融科技大獎
                        </div>

                         <div class="qian-jian1">
                              <div>IFTA FinTech  Achievement Award 2019</div>
                              <div style="text-align:center">  </div>
                        </div>

               </div> -->
        </div>
   </div>
   <!-- 合作伙伴 -->
   <div>
          <div>
                   <div  class="ye-tou">
                    商業合作夥伴
                  </div>
                <div class="ye-scope">
                  —— BUSINESS PARTNERS ——
               </div>
               <div class="he-zuo">
                    <div>
                      <img class="wei-img" src="../../static/imgs/weixin.png" alt="">
                    </div>
                    <div style="width:43px">

                    </div>
                    <div>
                       <img class="wei-img" src="../../static/imgs/zhifubao.png" alt="">
                    </div>
               </div>
               <div style="text-align:center;margin-top:20px;">
                    <img  class="di-img" src="../../static/imgs/didi.png" alt="">
               </div>
          </div>
   </div>
   <!-- 联络我们 -->
  <div>
        <div class="lian-wo">
             <div  class="ye-tou">
                    聯絡我們
                  </div>
                <div class="ye-scope">
                  —— CONTACT US ——
               </div>
               <div class="lian-us">
                          <div>
                            <img class="er-img" src="../../static/imgs/erwima.png" alt="">
                              <div class="lian-right">
                                  <div @click="book">
                                    <img class="nian-img" src="../../static/imgs/nianshu.png" alt="">
                                  </div>
                                  <div @click="Whatsapp">
                                    <img class="hua-img" src="../../static/imgs/dianh.png" alt="">
                                  </div>
                                  <div @click="wei">
                                    <img class="bo-img" src="../../static/imgs/weibo.png" alt="">
                                  </div>
                               </div>
                          </div>
                          <div>
                              <div class="lian-luo"> 聯絡電話：+852 5371 8008</div>
                              <div class="lian-luo2">Email：info@unipock.com</div>
                                <div class="lian-luo1">
                                 地址: Suites 2201-2203, 22/F Yardley Commercial Building, 3 Connaught Road West, H.K.
                             </div>

                          </div>
               </div>


        </div>
        <div class="di-tu">
                     <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d922.934410308808!2d114.15023499999997!3d22.287926000000006!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x541369260bf0aa28!2z5YSE5Yip5ZWG5qWt5aSn5buI!5e0!3m2!1sen!2shk!4v1642645494747!5m2!1sen!2shk" width="100%" height="192" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
               </div>
  </div>

 <div class="foot">
       <div class="foot-hk">
         Copyright © 2023 Universal Pocket (H.K.) Co. Ltd
      </div>
      <div class="foot-ba">
         粤ICP备17140331号-1
      </div>
 </div>

</div>


</template>

<script>

import {Login} from "../../src/api/http"

export default {
  data () {
    return {
      listbiao:[
         {url:'https://mp.weixin.qq.com/s?__biz=MzU3OTExMTkwMA==&mid=2247491227&idx=1&sn=b5b3dbeeb5978ee8a419e074c6a0cd83&chksm=fd6a4028ca1dc93e7616bb2722811d16bb5c0c19f88003b47e62d9144b445a793505aecbe217&token=1327790049&lang=zh_CN#rd',text:'澳门快速支付系统FPS“过数易”试行运作'},
         {url:'https://mp.weixin.qq.com/s?__biz=MzU3OTExMTkwMA==&mid=2247491227&idx=2&sn=d0c93bf2600e6507eceb382ec13f6d47&chksm=fd6a4028ca1dc93ed285bb357e26af6e9b25b97d65336e8d4ecfa72a1a693c8fcc489b7c6119&token=1327790049&lang=zh_CN#rd',text:'Visa发布消费者支付报告：52％消费者经常使用电子钱包'},
        {url:'https://mp.weixin.qq.com/s?__biz=MzU3OTExMTkwMA==&mid=2247491227&idx=3&sn=14f75e9f8ef1ad75d0f9bf9849d9f42d&chksm=fd6a4028ca1dc93e179716649095acca39d8affceafc3017faa4cc94cd86de40ac3f888e6481&token=1327790049&lang=zh_CN#rd',text:'我国快递年业务量首次突破千亿件大关'},
        {url:'https://mp.weixin.qq.com/s?__biz=MzU3OTExMTkwMA==&mid=2247491227&idx=4&sn=96e331eebdec5309c8cf693d49cf741c&chksm=fd6a4028ca1dc93ee7c17f95ffcc07daa325f875f3211a7a69a3271c5d364a26285fbb2a0588&token=1327790049&lang=zh_CN#rd',text:'淘宝发布《淘宝卖家行为学》'},
         {url:'https://mp.weixin.qq.com/s?__biz=MzU3OTExMTkwMA==&mid=2247491194&idx=1&sn=f4742620024106c59d9300144424800c&chksm=fd6a40c9ca1dc9df1adcf7e31a78cc609d6ad4e5473740584d4b6ba32c203a7efff735059f90&token=1656351502&lang=zh_CN#rd',text:'香港10月零售业销售额按年升12% 专家：料消费继续增长'},
          {url:'https://mp.weixin.qq.com/s?__biz=MzU3OTExMTkwMA==&mid=2247491194&idx=2&sn=d53576a55925dd6f478e5d8b36013598&chksm=fd6a40c9ca1dc9dfe6bcd82d085a988c204c333f9aed641b15feb8911e1c086ace36ffc0ffea&token=1656351502&lang=zh_CN#rd',text:'香港入境处推出二维码配合容貌识别自助过关'},
      ],
      list:[{ name:'首頁', cm:"demo"},
      { name:'業務範圍', cm:"demo1"},
      { name:'優勝之處', cm:"demo2"},
      { name:'策略合作夥伴', cm:"demo3"},
      { name:'最新動態', cm:"demo4"},
      { name:'關於我們', cm:"demo5"},
      { name:'合作夥伴', cm:"demo6"},
      { name:'聯絡我們', cm:"demo7"},

            ],
      show:false,
      tableData:[],
      swich:false,
      nav:false,
       screenWidth:true,
       offsetWidth: document.body.clientWidth,
      direction:'horizontal',
      realIndex:0,
      swipertion: {
          autoplay:true,
          direction: 'horizontal',
          loop:true,
        mode:"horizontal",
        delay: 3000,
          pagination: {
            el: '.swiper-pagination',
            clickable:true
          }
        },


    }
  },
  created(){

 this.detail();
  },
  computed: {


  },
  watch:{

  },
  mounted(){
       document.addEventListener('click',(e)=>{
      let thisClassName = e.target.className;

      if(thisClassName=='popContainer'){
           this.show=false;

      }
      if(thisClassName =='ma-img'){
           this.imgs=true;
      }else{
         this.imgs=false;
          console.log('thisClassName',thisClassName);
      }

   })
  },
  methods:{
    detail(){
        let data1={
          url:'http://hkshcms.unipock.net/index.php?s=news&c=home&m=list_news'
        }
  Login(data1).then(res=>{

   this.tableData=res.data.info.slice(0, 6);



  })
    },
    cxc(){
       window.open("http://cxc.com.hk/")
    },
       Whatsapp(){
       window.open('https://api.whatsapp.com/send?phone=85253718008')
    },
    wei(){
         window.open('https://weibo.com/u/6632850671')
    },
    book(){
      window.open('https://www.facebook.com/UniversalPocketHK')
    },
    leave(){
       this.$router.push("/leave")
    },
       Digital(){
           this.$router.push("/digit")
       },
    pay(){
         this.show=true;
    },

   gan(val){
   window.open(val)
   },

   changeTab(){

   },

}
}
</script>

<style  scoped>
	@media (max-width: 321px) {
    .qian-img{
      width: 305px !important;
    }
    .zui-teng{
      width: 73% !important;
    }
    .liao-img{
      width: 150px !important;
    }
  }
.te-tex{
  position: relative;
  text-align: center;
}
.cha-img{
  position: absolute;
  right: 10px;
  top:10px;
  width: 10px;
  height: 10px;
}
.xing-img{
  width: 150px;
  height: 28px;
}
.te-duo{
  position: absolute;
  top:5px;
  left:100px;


font-size: 18px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;
line-height: 21px;

}
.te-tan{
  display: flex;
  justify-content: center;
  margin-top:40px;
}
.xin-img{
  width: 71px;
  height: 25px;
}
.xi-img{
  width: 85px;
  height: 22px;
}
.bada-img{
  width:62px;
  height: 25px;
}
.mast-img{
  width:41px;
  height: 25px;
}

.vlst-img{
  width: 85px;
  height: 27px;
}
.te-mt{
  margin-right: 30px;
}
.ye-fix{
  position: fixed;
   top:0;
   left:0;
   right: 0;
   bottom: 0;
  margin:auto;
   width:310px;
   height: 183px;
   background: #fff;
   border-radius: 16px;
}
.te-tan1{
  display: flex;
  justify-content: center;
  margin-top:20px;
}
.popContainer{
  z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
}
.foot-hk{

font-size: 10px;
font-family: Arial;
font-weight: 400;
color: #FFFFFF;
line-height: 22px;
}
.foot-ba{
   font-size: 10px;
font-family: Arial;
font-weight: 400;
color: #FFFFFF;
}
.foot{
  height: 40px;
  width: 100%;
  text-align: center;
  background-color:#10BBB8 ;
}
.lian-right{
  display: flex;
  margin-left:24px;
  margin-top:10px;
}
.nian-img{
  width: 24px;
  height: 25px;
}
.bo-img{
  width: 30px;
  height: 24px;
   margin-left:20px;
}
.hua-img{
  width: 26px;
  height: 24px;
  margin-left:20px;
}
.di-tu{
  width: 100%;
  height: 192px;
  background-color: #f5f5f5;
}
.lian-luo{

margin-left: 20px;
font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #333333;


}
.cha_xun{
  width:92px;
  text-align: center;
  font-size:14px;
  margin-top:10px;
  font-weight: bold;
}
.lian-luo1{
  margin-top:5px;
margin-left: 20px;
margin-right:10px;
font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #333333;
line-height: 1.7;


}
.lian-luo2{
margin-top:8px;
margin-left: 20px;

font-size: 15px;

font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #333333;

}
.lian-us{
  margin-top:20px;
  display: flex;

}
.lian-wo{
  margin-top:35px;
  width: 100%;
  height: 291px;
  background-color: #f5f5f5;
  padding: 1px;
}
.wei-img{
  width: 104px;
  height: 104px;
 }
 .di-img{
     width: 270px;
  height: 80px;
 }
 .er-img{
   margin-left:24px;
   width: 118px;
   height: 118px;
 }
.he-zuo{
  margin-top:20px;
  display: flex;
  justify-content: center;
}
.qian-text{
  display: flex;
  justify-content: space-between;
   margin-top:20px;
}
.qian-jian{
margin-top:20px;
margin-bottom: 20px;
  text-align: center;
font-size: 16px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;
line-height: 15px;

}
.qian-jian1{
  margin-top:20px;
text-align: center;
font-size: 16px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;
line-height: 15px;

}
.guan-tong{
  /* display: flex;
  justify-content: space-between; */
  margin-top:20px;
}
.jiang-img{

  width: 240px;
  height: 330px;
}
.qian-img{

  width: 320px;
  height: 200px;
  text-align: center;
}
.guan-text{
  margin-top:10px;
  text-align: center;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;
line-height: 21px;
}
.guan-login{
  margin-top:20px;
 text-align: center;
font-size: 18px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;

}
.guan-ab{
   margin-top: 8px;
  text-align: center;
font-size: 9px;
font-family: Arial;
font-weight: 400;
color: #ffffff;
line-height: 21px;
}
.guan-tou{


font-family: Alibaba PuHuiTi;
font-weight: bold;
color: #ffffff;

   margin-top:27px;
   text-align: center;
   font-size: 24px;
   font-family: AlibabaPuHuiTiB;

}
.guan-kuang{
  padding: 1px;
  height: 850px;
  width: 96%;
  margin:0 auto;
  background-color: #10BBB8;
}
.jian-img{
  width: 6px;
  height: 9px;
  vertical-align: middle;
  margin-top: -2px;
}
.zui-ri{

font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #414141;

}
.zui-teng{
  margin-left:10px;
text-decoration: none;
    width: 76%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #000000;

}
.zui-text{
  width: 96%;
  margin:0 auto;
  display: flex;
  align-items: center;
  height: 44px;
  border-bottom: 1px dashed #d2d2d2;
}
.cxc-jian{
 margin-top: 17px;
font-size: 10px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #5A5A5A;
margin-right: 10px;
}
.cxc-text{
font-size: 17px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #000000;
line-height: 21px;
}
.cxc-kuai{
  margin-left:20px;
}
.cxc-img{
  width: 80px;
  height: 94px;
  margin-left: 8px;
  margin-top:5px;

}
.ce-cxc{
  display: flex;
  margin-top: 20px;

}
.ce-tou{
  padding: 1px;
  margin-top:27px;
  width: 100%;
  height: 275px;
  background-color:#f5f5f5;
}
.bian-text{
  margin-left:15px;
  width: 60px;
height: 30px;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #666666;

}
.liao-kuang{
  width: 168px;
  height: 172px;

}
.bian-text1{
  margin-left:15px;
  width: 72px;
height: 30px;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #666666;

}
.bian-text2{
  margin-left:15px;
  width: 50px;
height: 30px;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #666666;

}
.bian-text3{
  margin-left:15px;
  width: 68px;
height: 30px;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #666666;

}

.bian-img{
  width: 53px;
  height: 53px;
}
.bian-left{
  display: flex;
  align-items: center;
  margin-left:20px;
 width: 55%;

}
.bian-right{
   display: flex;
  align-items: center;
  margin-right:25px;
width: 45%;
}
.bian{
  display: flex;
  justify-content: space-around;
  margin-top:20px;
}
.bian1{
  display: flex;
  justify-content: space-between;
  margin-top:17px;
}
.ye-zhi{
  margin-top:15px;
  text-align: center;
font-size: 18px;
font-family: Alibaba PuHuiTi;
font-weight: bold;
color: #FFFFFF;

}
.ye-jiao{
  display: flex;
  justify-content: space-around;
  margin-top:10px;
}
.liao-img{
  width: 168px;
  height: 128px;
  display:block;
}
.yin-liao{
  height: 44px;
  background-color: #FFFFFF;
  text-align: center;
  line-height: 44px;
 font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #333333;

}
.ye-liao{
  padding: 1px;
  width: 96%;
  height: 441px;
  margin: 30px auto;
  background-color: #10BBB8;

}
.ye-xu{
  width: 96%;
  margin:20px auto;

border: 1px dashed #B5B5B5;
opacity: 0.5;
}
.ye-ji{
margin-top:5px;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #999999;
 margin-right: 16px;
}
.ye-shu{

font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #333333;

}
.xiao-img{
  width: 56px;
  height: 56px;
}
.ye-shuo{
  width: 96%;
  margin: 0 auto;
   margin-top:30px;
   display: flex;

}
.ye-yin{
 margin-top:30px;
text-align: center;
font-size: 18px;
font-family: Alibaba PuHuiTi;
font-weight: bold;
color: #10BBB8;
line-height: 21px;
}
.ye-kai{
 margin-left:16px;
 margin-right: 15px;
font-size: 12px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;

}
.ye-left{
  margin-top:12px;
  margin-left:15px;
  margin-bottom: 13px;
}
.ye-span{
  margin-left:9px;
  width: 105px;
height: 15px;
font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: bold;
color: #FFFFFF;
line-height: 21px;
}
.shu-img{
  height: 21px;
  width: 21px;
  vertical-align: middle;
}
.ye-text{
 padding: 1px;
  width: 96%;
  height: 94px;
  margin:0 auto;
  margin-top:20px;
  background-color: #10BBB8;
}
.ye-text1{
 padding: 1px;
  width: 96%;
  height: 113px;
  margin:0 auto;
  margin-top:10px;
  background-color: #10BBB8;
}
.ye-text2{
 padding: 1px;
  width: 96%;
  height: 119px;
  margin:0 auto;
  margin-top:10px;
  background-color: #10BBB8;
}
 .ye-tou{

font-family: Alibaba PuHuiTi;
font-weight: bold;
color: #333333;

   margin-top:27px;
   text-align: center;
   font-size: 24px;
   font-family: AlibabaPuHuiTiB;
 }
 .ye-scope{
   margin-top: 8px;
  text-align: center;
font-size: 9px;
font-family: Arial;
font-weight: 400;
color: #BBBBBB;
line-height: 21px;
 }

</style>



// WEBPACK FOOTER //
// src/views/home.vue